import PathFinding from "./PathFinding/PathFinding";
function App() {
  return (
    <div className="App">
      <PathFinding></PathFinding>
    </div>
  );
}

export default App;